import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          更新动态
        </h2>
        <div className="max-w-[900px] mx-auto">
          {updatesData.map((item, i) => (
            <div
              key={i}
              className="relative pl-8 pb-8 last:pb-0 border-l-2 border-background-300 last:border-transparent"
            >
              <div className="absolute left-[-7px] top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
              <div className="flex flex-wrap items-center gap-2 mb-1.5">
                <span className="text-xs text-foreground-400">{item.date}</span>
                <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[11px] font-semibold whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1.5">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.summary}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}